// Client V2 common imports
const { COLLECTION_DELETED } = require('client-v2/common/models/collection/actions')
const { navigateToUserProfileCollections } = require('client-v2/common/models/user/actions')

function collectionProfileMiddleware() {
  return store => next => action => {
    if (action.type === COLLECTION_DELETED) {
      const { collection } = store.getState()
      const { collectionId } = action.payload
      if (collectionId === collection.id) {
        store.dispatch(navigateToUserProfileCollections({
          user: collection
        }))
      }
    }
    next(action)
  }
}

module.exports = collectionProfileMiddleware
